import { render, staticRenderFns } from "./ControleAcesso.vue?vue&type=template&id=78914ee4&"
import script from "./ControleAcesso.vue?vue&type=script&lang=js&"
export * from "./ControleAcesso.vue?vue&type=script&lang=js&"
import style0 from "./ControleAcesso.vue?vue&type=style&index=0&id=78914ee4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports